import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

import Navbar       from './components/Navbar';
import Footer       from './components/Footer';
import Home         from './pages/Home';
import Tours        from './pages/Tours';
import TourDetail   from './pages/TourDetail';
import Booking      from './pages/Booking';
import Contact      from './pages/Contact';
import About        from './pages/About';
import Houseboats   from './pages/Houseboats';
import Destinations from './pages/Destinations';
import Activities   from './pages/Activities';
import AdminLogin   from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />

          {/* Public routes */}
          <Route path="/*" element={
            <>
              <Navbar />
              <Routes>
                <Route path="/"             element={<Home />} />
                <Route path="/tours"        element={<Tours />} />
                <Route path="/tours/:slug"  element={<TourDetail />} />
                <Route path="/book/:tourId" element={<Booking />} />
                <Route path="/contact"      element={<Contact />} />
                <Route path="/about"        element={<About />} />
                <Route path="/houseboats"   element={<Houseboats />} />
                <Route path="/destinations" element={<Destinations />} />
                <Route path="/activities"   element={<Activities />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
